import { useMemo } from 'react'
import { useMyRestaurant } from '@/lib/queries/useRestaurants'
import type { Restaurant } from '@/lib/queries/useRestaurants'

export const DEFAULT_POS_CURRENCY = 'EUR'

export function formatPOSMoney(amount: number, currency = DEFAULT_POS_CURRENCY) {
  const code = (currency || DEFAULT_POS_CURRENCY).trim().toUpperCase()
  try {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: code,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount)
  } catch {
    return `${code} ${amount.toFixed(2)}`
  }
}

export function restaurantFromResponse(response: unknown): Restaurant | null {
  const data = (response as any)?.data
  if (Array.isArray(data)) return data[0] ?? null
  return data ?? null
}

export function usePOSCurrency() {
  const { data: restaurantResp } = useMyRestaurant()
  const restaurant = restaurantFromResponse(restaurantResp)
  return useMemo(
    () => (restaurant?.currency?.trim() || DEFAULT_POS_CURRENCY).toUpperCase(),
    [restaurant?.currency],
  )
}
